import type { AdminProfile } from '@/domain/profile/entities/admin_profile.entity'
import type { AdminProfileDto } from '../dto/admin_profile.dto'

function unwrapPayload(data: unknown): Record<string, unknown> {
  if (!data || typeof data !== 'object') return {}
  const root = data as Record<string, unknown>
  const inner = root.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    return inner as Record<string, unknown>
  }
  return root
}

export function mapAdminProfileDto(raw: unknown): AdminProfileDto {
  const o = unwrapPayload(raw)
  return {
    id: String(o.id ?? ''),
    email: String(o.email ?? ''),
    name: String(o.name ?? o.email ?? 'Admin'),
    createdAt:
      typeof o.createdAt === 'string'
        ? o.createdAt
        : typeof o.created_at === 'string'
          ? o.created_at
          : undefined,
    updatedAt:
      typeof o.updatedAt === 'string'
        ? o.updatedAt
        : typeof o.updated_at === 'string'
          ? o.updated_at
          : undefined,
  }
}

export function mapAdminProfileDtoToEntity(dto: AdminProfileDto): AdminProfile {
  return {
    id: dto.id,
    email: dto.email,
    name: dto.name,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
